module.exports = __webpack_public_path__ + "static/media/popularSpaceBadge.705ab3b4.svg";